const LoadingDots = ({ text }: { text: string }) => {
  return (
    <span className="relative after:text-gray-500 after:animate-dots after:absolute after:content-['.'] pr-1">
      {text}
    </span>
  )
}

export { LoadingDots }
